import React from "react";
import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";

interface IShowMore {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const ShowMore: React.FunctionComponent<IShowMore> = (props) => (
  <div
    css={{
      padding: 15,
      textTransform: "uppercase",
      color: palette.sealBlue,
      fontSize: 12,
      textAlign: "center",
      cursor: "pointer",
      borderTop: `solid 1px ${palette.lightestGray}`,
      "&:hover": {
        color: palette.darkGray,
      },
    }}
    role="button"
    aria-label="Show more"
    {...props}
  >
    <FormattedMessage defaultMessage="Show more" id="aWpBzj" />
  </div>
);
